export class Searchgeneral {

    itemCategoryCode: string;
    boqCategory: string;
    boqSubCategory: string;
    boqSubSubCategory: string;
    desc: string;

    category: string;
    itemNo: string;
    serviceNo: string;

    type: string;

    enqNavRfqNo: string;
    quoteNavRfqNo: string;

    navIndentNo: string;
    navRfqNo: string;
    navEnquiryNo: string;
    navQuoteNo: string;
    navPoNo: string;
    navGrnNo: string;
    navPurchaseInvoiceNo: string;
    vendorInvoiceNo: string;
    amount: string;
    navPaymentNo: string;

    dateFrom: Date;
    dateTo: Date;

    id:number
    projectid: string

    extendNavRfqNo: string;
    extendText: string;
    extendDate: Date;

    submitText: string;
    submitQuoteId: number;

    reqQuoteText: string;
    reqQuoteId: number;
    reqQuoteWorkflowId: number;

    reqRfqId: number;
    reqRfqWorkflowId: number;

    reqGrnId: number;
    reqGrnWorkflowId: number;

    reqPurInvId: number;
    reqPurInvWorkflowId: number;

    vendorNo: string;
    locName: string;
    locationName: string;
    deptName: string;

    companyName: string;
    vendorName: string;
    vendorId: number;
    branchId: number;
    workflowName: string;
    roleName: string;
    fullName: string;
    countryId: string;
    status:string;


    invoicedAmount:string;
    summary:string;
    description:string;
    navInvoiceNo:string;
    invoiceDate:Date;
    name:string;
}
